export const wishes = {
  fortune: [
    {
      money: "올해는 예상치 못한 재운의 기회가 찾아올 것입니다. 봄철, 특히 4월과 5월 사이에 작은 행운의 기회가 찾아오겠지만, 충동적인 투자는 주의하세요. 9월에는 부수입의 기회가 열릴 것이며, 연말에는 작지만 의미 있는 재정적 성장을 경험하게 될 것입니다.",
      love: "올해는 감정의 롤러코스터를 탑승하게 될 것입니다! 상반기에는 소극적인 태도가 연애의 기회를 놓칠 수 있으니, 용기를 내보세요. 가을에는 특별한 만남이 예상되며, 이 인연은 당신의 마음에 깊은 울림을 줄 것입니다. 특히 10월의 보름달 무렵, 운명적인 만남이 기다리고 있습니다.",
      person: "'카키색 재킷을 입은 40대 중반의 여성'\n부드러운 미소와 차분한 말투를 가진 이 귀인은 당신에게 중요한 조언과 기회의 문을 열어줄 것입니다."
    },
    {
      money: "2025년은 꾸준한 노력이 결실을 맺는 해입니다. 3월부터 시작된 작은 변화가 7월에 큰 기회로 이어질 것입니다. 특히 여름철에는 의외의 수입원이 생기며, 12월에는 오랫동안 준비해온 프로젝트가 안정적인 수익을 가져올 것입니다.",
      love: "올해는 진정한 소통의 시기입니다. 봄에는 약간의 흔들림이 있을 수 있으나, 이는 더 깊은 이해로 가는 과정이 될 것입니다. 8월에는 특별한 인연과의 만남이 예상되며, 이 만남은 당신의 가치관에 긍정적인 영향을 줄 것입니다.",
      person: "'남색 정장을 입은 50대 초반의 남성'\n날카로운 통찰력과 부드러운 카리스마를 가진 이 귀인은 당신의 성장을 이끌어주는 멘토가 될 것입니다."
    },
    {
      money: "창의적인 아이디어가 수익으로 이어지는 해입니다. 2월과 6월 사이에 새로운 기회가 찾아오며, 평소 관심 있던 분야에서 예상치 못한 수입이 생깁니다. 가을에는 투자한 것에 대한 첫 결실을 맺게 될 것입니다.",
      love: "마음의 여유가 사랑을 부르는 해입니다. 봄에는 잠시 휴식을 가지며 자신을 돌아보는 시간이 필요합니다. 여름 말, 특히 8월 말에서 9월 초 사이에 의미 있는 만남이 예상되며, 이는 오랫동안 지속될 인연이 될 것입니다.",
      person: "'보라색 스카프를 한 30대 후반의 여성'\n예술적 감각과 따뜻한 마음을 가진 이 귀인은 당신에게 새로운 시각과 영감을 선물할 것입니다."
      
    },
    {
      money: "안정적인 성장이 기대되는 해입니다. 5월에는 새로운 재테크 기회를 발견하게 되며, 여름철에는 꾸준한 저축의 결실을 맺게 됩니다. 10월에는 의외의 수익이 발생하나, 신중한 판단이 필요한 시기입니다.",
      love: "진실된 마음이 통하는 해입니다. 봄에는 약간의 시행착오를 겪을 수 있으나, 이는 더 나은 관계로 발전하는 계기가 됩니다. 가을에는 특별한 인연과의 만남이 예상되며, 이 만남은 당신의 삶에 새로운 활력을 불어넣을 것입니다.",
      person: "'갈색 가죽 가방을 든 40대 초반의 남성'\n실용적인 지혜와 넓은 안목을 가진 이 귀인은 당신에게 실질적인 도움과 조언을 줄 것입니다."
    },
    {
      money: "새로운 도전이 결실을 맺는 해입니다. 봄에는 작은 시도가 예상치 못한 수익으로 이어지며, 여름에는 평소 관심 있던 분야에서 기회가 찾아옵니다. 11월에는 오랫동안 준비해온 일이 안정적인 수입원이 될 것입니다.",
      love: "솔직한 표현이 행운을 부르는 해입니다. 봄에는 자신의 감정에 더 집중하는 시간이 필요합니다. 7월 말에서 8월 초 사이에 특별한 만남이 예상되며, 이는 당신의 삶에 새로운 변화를 가져올 것입니다.",
      person: "'회색 코트를 입은 30대 중반의 여성'\n섬세한 통찰력과 긍정적인 에너지를 가진 이 귀인은 당신에게 새로운 기회와 영감을 전해줄 것입니다."
    },
    {
      money: "숨겨진 재능이 빛을 발하는 해입니다. 3월에는 취미로 시작한 일이 수익으로 연결되며, 6월에는 의외의 제안을 받게 됩니다. 가을에는 새로운 분야에서의 성과가 두드러지며, 연말에는 안정적인 수입원이 생길 것입니다.",
      love: "내면의 성장이 사랑을 부르는 해입니다. 봄에는 자기계발에 집중하는 것이 좋습니다. 9월 무렵, 같은 관심사를 가진 사람과의 특별한 만남이 예상되며, 이는 깊이 있는 관계로 발전할 수 있습니다.",
      person: "'빈티지 안경을 쓴 20대 후반의 남성'\n창의적인 사고와 독특한 개성을 가진 이 귀인은 당신에게 새로운 트렌드와 기회를 소개할 것입니다."
    },
    {
      money: "꾸준함이 행운을 부르는 해입니다. 4월부터는 일상적인 습관이 예상치 못한 수익으로 이어지며, 8월에는 오래 준비해온 일의 첫 결실을 맺게 됩니다. 특히 하반기에는 새로운 재물운의 기회가 찾아올 것입니다.",
      love: "신중한 선택이 행복을 부르는 해입니다. 여름까지는 차분히 자신을 돌아보는 시간을 가지세요. 10월경에는 운명적인 만남이 있을 것이며, 이는 당신의 가치관과 잘 맞는 사람일 것입니다.",
      person: "'에메랄드 목걸이를 한 40대 중반의 여성'\n지적인 매력과 따뜻한 리더십을 가진 이 귀인은 당신의 경력에 새로운 전환점을 만들어줄 것입니다."
    },
    {
      money: "작은 기회가 큰 성과로 이어지는 해입니다. 5월에는 우연한 정보가 중요한 수익으로 연결되며, 7월에는 새로운 투자 기회를 발견하게 됩니다. 가을에는 꾸준히 해온 일이 인정받는 시기입니다.",
      love: "자연스러운 인연이 찾아오는 해입니다. 봄에는 일상적인 만남 속에서 특별한 인연을 발견하게 됩니다. 8월 중순에는 의미 있는 관계의 진전이 있을 것이며, 이는 오래도록 지속될 인연입니다.",
      person: "'브라운 베레모를 쓴 30대 초반의 여성'\n예술가적 감성과 실용적인 지혜를 가진 이 귀인은 당신에게 새로운 라이프스타일을 제안할 것입니다."
    },
    {
      money: "전문성이 빛을 발하는 해입니다. 2월부터 시작된 공부가 6월에 첫 결실을 맺으며, 여름에는 새로운 자격증이나 기술이 수익으로 이어집니다. 11월에는 의미 있는 성과가 기대됩니다.",
      love: "성숙한 사랑이 찾아오는 해입니다. 봄에는 과거의 인연과 정리하는 시간을 가지게 됩니다. 가을에는 진중한 만남이 시작될 것이며, 이는 당신의 인생에 큰 의미를 가져다줄 것입니다.",
      person: "'네이비 스웨터를 입은 50대 후반의 남성'\n풍부한 경험과 넓은 식견을 가진 이 귀인은 당신에게 인생의 중요한 가르침을 전할 것입니다."
    },
    {
      money: "협력이 행운을 부르는 해입니다. 3월에는 뜻밖의 동업 제안이 들어오며, 여름에는 공동 프로젝트가 좋은 성과를 냅니다. 10월에는 새로운 파트너십으로 인한 수익이 발생할 것입니다.",
      love: "열린 마음이 행복을 부르는 해입니다. 봄에는 새로운 환경에서의 만남이 기대됩니다. 7월경에는 예상치 못한 장소에서 특별한 인연을 만나게 될 것이며, 이는 서로에게 긍정적인 영향을 줄 것입니다.",
      person: "'버건디 셔츠를 입은 30대 중반의 남성'\n진취적인 사고와 친화력을 가진 이 귀인은 당신에게 새로운 네트워크의 기회를 제공할 것입니다."
    },
    {
      money: "도전이 성과로 이어지는 해입니다. 4월에는 새로운 분야에 대한 투자가 시작되며, 8월에는 예상치 못한 수익원이 생깁니다. 연말에는 위험을 감수한 선택이 큰 보상으로 돌아올 것입니다.",
      love: "용기 있는 표현이 행운을 부르는 해입니다. 5월에는 마음에 둔 사람에게 적극적으로 다가가보세요. 가을에는 오랜 짝사랑이 결실을 맺을 수 있으며, 이는 예상보다 더 달콤한 결과를 가져올 것입니다.",
      person: "'올리브 재킷을 입은 40대 초반의 여성'\n결단력 있는 성격과 따뜻한 마음을 가진 이 귀인은 당신의 중요한 결정에 힘이 되어줄 것입니다."
    },
    {
      money: "신중한 판단이 행운을 부르는 해입니다. 봄에는 큰 지출을 피하고 정보 수집에 집중하세요. 9월부터는 준비해온 계획이 실현되기 시작하며, 12월에는 의미 있는 투자 성과가 나타날 것입니다.",
      love: "진정성이 통하는 해입니다. 상반기에는 자신의 진정한 모습을 보여주는 것이 중요합니다. 8월에는 오랜 친구와의 관계가 특별해질 수 있으며, 이는 서로에 대한 깊은 이해를 바탕으로 할 것입니다.",
      person: "'파스텔 블루 원피스를 입은 20대 후반의 여성'\n순수한 열정과 긍정적인 에너지를 가진 이 귀인은 당신에게 새로운 시각과 활력을 선물할 것입니다."
    },
    {
      money: "경험이 자산이 되는 해입니다. 5월에는 과거의 인맥이 새로운 기회로 연결되며, 여름에는 오래된 아이디어가 빛을 발합니다. 가을에는 축적된 노하우가 예상치 못한 수익을 가져올 것입니다.",
      love: "인연의 순환이 완성되는 해입니다. 봄에는 과거의 인연과 우연한 재회가 있을 수 있습니다. 11월에는 오래 기다려온 사람과의 관계가 새로운 단계로 발전하며, 이는 운명적인 만남이 될 것입니다.",
      person: "'체크무늬 코트를 입은 40대 후반의 남성'\n깊이 있는 통찰력과 포용력을 가진 이 귀인은 당신의 인생에 새로운 방향성을 제시할 것입니다."
    },
    {
      money: "변화가 기회가 되는 해입니다. 3월에는 예상치 못한 제안이 들어오며, 7월에는 새로운 환경에서의 기회가 생깁니다. 10월에는 과감한 결정이 긍정적인 결과로 이어질 것입니다.",
      love: "새로운 시작이 기다리는 해입니다. 봄에는 낯선 환경에서의 설렘이 있습니다. 9월경에는 공통의 취미를 통해 특별한 인연을 만나게 될 것이며, 이는 당신의 생활에 즐거운 변화를 가져올 것입니다.",
      person: "'와인색 터틀넥을 입은 30대 후반의 여성'\n창의적인 사고와 실행력을 가진 이 귀인은 당신에게 혁신적인 아이디어와 기회를 제공할 것입니다."
    },
    {
      money: "준비가 기회를 만드는 해입니다. 4월에는 꾸준히 준비해온 분야에서 성과가 나타나며, 8월에는 새로운 교육이나 자격증이 도움이 됩니다. 연말에는 전문성을 인정받아 큰 보상이 따를 것입니다.",
      love: "성장하는 사랑이 찾아오는 해입니다. 6월에는 서로를 이해하는 시간이 필요합니다. 가을에는 함께 성장할 수 있는 특별한 인연을 만나게 될 것이며, 이는 당신의 인생에 새로운 동기부여가 될 것입니다.",
      person: "'베이지색 트렌치코트를 입은 30대 초반의 남성'\n체계적인 사고와 따뜻한 배려심을 가진 이 귀인은 당신의 성장을 지원하고 새로운 기회를 연결해줄 것입니다."
    },
    {
      money: "창의력이 수익이 되는 해입니다. 2월에는 독특한 아이디어가 주목받으며, 5월에는 온라인 플랫폼에서 새로운 기회가 찾아옵니다. 가을에는 당신만의 특별한 콘텐츠가 큰 호응을 얻을 것입니다.",
      love: "색다른 만남이 기다리는 해입니다. 봄에는 취미 활동을 통해 특별한 인연이 찾아옵니다. 7월에는 온라인에서 시작된 관계가 오프라인에서 더욱 발전하며, 이는 예상치 못한 설렘을 가져올 것입니다.",
      person: "'민트색 후드티를 입은 20대 중반의 남성'\n디지털 감각과 트렌디한 마인드를 가진 이 귀인은 당신에게 새로운 시대의 기회를 알려줄 것입니다."
    },
    {
      money: "소소한 행복이 큰 기회가 되는 해입니다. 3월에는 일상적인 취미가 수익으로 연결되며, 6월에는 SNS를 통한 부수입이 생깁니다. 연말에는 평소 즐기던 일이 안정적인 수입원이 될 것입니다.",
      love: "일상 속 로맨스가 피어나는 해입니다. 봄에는 매일 지나다니던 곳에서 특별한 인연을 만납니다. 8월에는 평범한 일상이 설레는 데이트로 바뀌며, 이는 달콤한 추억이 될 것입니다.",
      person: "'핑크색 앞치마를 한 30대 초반의 여성'\n밝은 에너지와 섬세한 감성을 가진 이 귀인은 당신의 일상에 특별한 영감을 불어넣을 것입니다."
    },
    {
      money: "지식이 자산이 되는 해입니다. 4월에는 전문 지식을 활용한 기회가 찾아오며, 7월에는 교육 관련 수입이 늘어납니다. 가을에는 당신의 경험을 나누는 것이 새로운 수익이 될 것입니다.",
      love: "지적 교감이 이어지는 해입니다. 봄에는 학습 모임에서 의미 있는 만남이 있습니다. 9월에는 서로의 성장을 돕는 관계가 시작되며, 이는 평생의 동반자가 될 수 있습니다.",
      person: "'골드 테두리 안경을 쓴 40대 중반의 남성'\n깊은 지식과 따뜻한 가르침을 가진 이 귀인은 당신의 성장을 이끄는 멘토가 될 것입니다."
    },
    {
      money: "인맥이 황금이 되는 해입니다. 5월에는 오래된 인연을 통해 좋은 기회가 오며, 8월에는 새로운 네트워크가 형성됩니다. 하반기에는 인적 네트워크를 통한 큰 이익이 예상됩니다.",
      love: "소셜 네트워크가 인연이 되는 해입니다. 봄에는 지인의 소개로 특별한 만남이 있습니다. 10월에는 업무 관계가 로맨스로 발전할 수 있으며, 이는 서로에게 긍정적인 시너지가 될 것입니다.",
      person: "'실버 넥타이를 맨 50대 초반의 남성'\n넓은 인맥과 풍부한 경험을 가진 이 귀인은 당신에게 귀중한 인연들을 소개할 것입니다."
    },
    {
      money: "디지털 시대의 기회가 찾아오는 해입니다. 3월에는 온라인 플랫폼에서 새로운 수익원을 발견하며, 7월에는 디지털 콘텐츠로 인한 수입이 늘어납니다. 연말에는 새로운 기술 투자가 결실을 맺을 것입니다.",
      love: "하이테크 로맨스가 시작되는 해입니다. 봄에는 소셜 미디어를 통해 특별한 인연을 만납니다. 가을에는 공통의 관심사로 시작된 대화가 깊은 관계로 발전하며, 이는 현대적인 로맨스의 좋은 예시가 될 것입니다.",
      person: "'스마트워치를 찬 20대 후반의 남성'\n디지털 전문성과 혁신적인 마인드를 가진 이 귀인은 당신에게 미래 산업의 인사이트를 제공할 것입니다."
    },
    {
      money: "글로벌한 기회가 찾아오는 해입니다. 4월에는 해외 거래처와의 인연이 시작되며, 8월에는 국제적인 프로젝트에 참여하게 됩니다. 연말에는 외국어 실력이 새로운 수익으로 이어질 것입니다.",
      love: "국제적인 로맨스가 기다리는 해입니다. 봄에는 외국어 학습을 통해 특별한 인연을 만납니다. 가을에는 문화적 차이를 넘어선 깊은 교감이 시작되며, 이는 당신의 시야를 넓혀줄 것입니다.",
      person: "'캐주얼한 정장을 입은 30대 후반의 외국인 남성'\n글로벌 감각과 개방적인 마인드를 가진 이 귀인은 당신에게 세계적인 기회를 소개할 것입니다."
    },
    {
      money: "건강과 재물이 함께 찾아오는 해입니다. 5월에는 웰빙 관련 투자가 성과를 내며, 9월에는 건강한 라이프스타일이 새로운 수익을 만듭니다. 연말에는 몸과 마음의 균형이 재물복으로 이어질 것입니다.",
      love: "건강한 사랑이 시작되는 해입니다. 봄에는 운동이나 요가 수업에서 특별한 인연을 만납니다. 가을에는 함께 성장하는 파트너십이 형성되며, 이는 신체적, 정신적 건강에도 좋은 영향을 줄 것입니다.",
      person: "'요가 매트를 든 30대 중반의 여성'\n건강한 에너지와 조화로운 삶을 실천하는 이 귀인은 당신에게 웰빙 라이프스타일을 전수할 것입니다."
    },
    {
      money: "예술적 감각이 수익이 되는 해입니다. 3월에는 창작 활동이 주목받기 시작하며, 6월에는 예술 관련 프로젝트에서 수익이 발생합니다. 가을에는 당신의 미적 감각이 새로운 사업 기회로 이어질 것입니다.",
      love: "예술적 교감이 이어지는 해입니다. 봄에는 문화 예술 공간에서 특별한 만남이 있습니다. 8월에는 공통의 미적 감각으로 시작된 관계가 깊어지며, 이는 서로에게 창의적 영감을 주는 관계가 될 것입니다.",
      person: "'아티스트 룩의 20대 후반 여성'\n예술적 감성과 창의적 에너지를 가진 이 귀인은 당신의 삶에 새로운 아름다움을 더해줄 것입니다."
    },
    {
      money: "친환경 가치가 기회가 되는 해입니다. 4월에는 지속 가능한 비즈니스 모델을 발견하며, 7월에는 환경 관련 프로젝트에서 수익이 발생합니다. 연말에는 사회적 가치와 경제적 이익이 조화를 이룰 것입니다.",
      love: "가치관이 통하는 사랑이 찾아옵니다. 봄에는 환경 보호 활동에서 특별한 인연을 만납니다. 가을에는 같은 목표를 향해 함께 걸어갈 파트너를 만나며, 이는 의미 있는 동행이 될 것입니다.",
      person: "'에코백을 멘 30대 초반의 여성'\n환경 의식과 사회적 책임감을 가진 이 귀인은 당신에게 지속 가능한 미래를 보여줄 것입니다."
    },
    {
      money: "전통이 새로운 가치가 되는 해입니다. 5월에는 전통 문화와 관련된 기회가 찾아오며, 8월에는 오래된 것의 현대적 재해석이 주목받습니다. 연말에는 과거의 지혜가 새로운 수익원이 될 것입니다.",
      love: "전통적 가치가 빛나는 해입니다. 봄에는 전통문화 행사에서 특별한 인연을 만납니다. 가을에는 서로의 가치관과 배경을 이해하는 깊은 관계가 시작되며, 이는 양가 가족 모두에게 축복받는 인연이 될 것입니다.",
      person: "'한복 디자이너 느낌의 40대 중반 여성'\n전통에 대한 깊은 이해와 현대적 감각을 가진 이 귀인은 당신에게 새로운 가치 창출의 기회를 전할 것입니다."
    },
    {
      money: "순수한 열정이 기회가 되는 해입니다. 4월에는 젊은 감각이 인정받으며, 7월에는 신선한 아이디어가 주목받습니다. 가을에는 당신의 패기 넘치는 도전이 예상 밖의 수익을 가져올 것입니다.",
      love: "청춘의 설렘이 가득한 해입니다. 봄에는 캠퍼스에서 운명적인 만남이 있습니다. 여름에는 친구에서 연인으로 발전하는 관계가 생기며, 이는 청춘드라마 같은 설렘을 선사할 것입니다.",
      person: "'교복을 입은 18살 여학생'\n순수한 에너지와 예리한 통찰력을 가진 이 귀인은 당신에게 잊고 있던 꿈과 열정을 일깨워줄 것입니다."
    },
    {
      money: "게임적 사고가 수익이 되는 해입니다. 3월에는 e스포츠 관련 기회가 찾아오며, 6월에는 게임 콘텐츠로 수익을 얻게 됩니다. 연말에는 디지털 엔터테인먼트 분야에서 성과가 기대됩니다.",
      love: "즐거운 취미가 인연을 만드는 해입니다. 봄에는 게임 커뮤니티에서 특별한 만남이 있습니다. 가을에는 함께 게임을 즐기는 사이에서 로맨스가 피어나며, 이는 즐거운 케미스트리를 만들어낼 것입니다.",
      person: "'게이밍 헤드셋을 쓴 16살 게이머'\n디지털 네이티브의 감각과 순수한 열정을 가진 이 귀인은 당신에게 새로운 트렌드의 기회를 알려줄 것입니다."
    },
    {
      money: "동심이 황금이 되는 해입니다. 5월에는 어린이 콘텐츠 관련 기회가 찾아오며, 8월에는 교육 사업에서 좋은 성과가 있습니다. 연말에는 순수한 아이디어가 큰 가치를 발휘할 것입니다.",
      love: "순수한 마음이 통하는 해입니다. 봄에는 동심을 자극하는 장소에서 특별한 만남이 있습니다. 가을에는 어린아이 같은 순수함을 가진 사람과의 인연이 시작되며, 이는 당신의 마음을 따뜻하게 할 것입니다.",
      person: "'크레파스를 든 12살 꼬마 화가'\n순수한 상상력과 창의적 영감을 가진 이 귀인은 당신에게 새로운 시각과 영감을 선물할 것입니다."
    },
    {
      money: "유쾌한 에너지가 기회를 부르는 해입니다. 2월에는 엔터테인먼트 분야에서 기회가 찾아오며, 6월에는 즐거운 아이디어가 수익으로 이어집니다. 가을에는 코미디 콘텐츠가 주목받을 것입니다.",
      love: "웃음이 인연을 만드는 해입니다. 봄에는 코미디 공연장에서 특별한 만남이 있습니다. 여름에는 유머러스한 대화가 로맨스로 발전하며, 이는 즐거운 데이트로 이어질 것입니다.",
      person: "'개그맨 지망생인 19살 청년'\n유쾌한 에너지와 재치 있는 말솜씨를 가진 이 귀인은 당신의 일상에 즐거운 변화를 가져올 것입니다."
    },
    {
      money: "음악적 재능이 빛나는 해입니다. 4월에는 음악 관련 수익이 생기며, 7월에는 예상치 못한 음악 프로젝트에 참여하게 됩니다. 연말에는 당신의 음악적 감각이 새로운 기회를 만들 것입니다.",
      love: "멜로디 같은 사랑이 찾아오는 해입니다. 봄에는 버스킹 공연장에서 운명적 만남이 있습니다. 가을에는 음악을 통해 마음이 통하는 사람을 만나며, 이는 아름다운 하모니가 될 것입니다.",
      person: "'기타를 메고 다니는 17살 청소년'\n음악적 재능과 순수한 열정을 가진 이 귀인은 당신의 삶에 새로운 리듬을 더해줄 것입니다."
    },
    {
      money: "스포츠 정신이 행운을 부르는 해입니다. 3월에는 체육 관련 기회가 찾아오며, 8월에는 스포츠 이벤트를 통해 수익이 생깁니다. 연말에는 건강한 열정이 새로운 사업 기회로 이어질 것입니다.",
      love: "활력 넘치는 만남이 기다립니다. 봄에는 운동 경기장에서 특별한 인연을 만납니다. 여름에는 함께 운동하는 사이에서 로맨스가 피어나며, 이는 건강한 파트너십으로 발전할 것입니다.",
      person: "'운동복을 입은 15살 체육특기생'\n건강한 에너지와 긍정적인 마인드를 가진 이 귀인은 당신에게 도전정신을 불어넣어줄 것입니다."
    },
    {
      money: "과학적 호기심이 수익이 되는 해입니다. 5월에는 연구 개발 분야에서 기회가 찾아오며, 9월에는 새로운 발견이 주목받습니다. 연말에는 실험정신이 큰 보상으로 이어질 것입니다.",
      love: "지적 호기심이 인연을 만드는 해입니다. 봄에는 과학관에서 특별한 만남이 있습니다. 가을에는 함께 탐구하고 연구하는 과정에서 로맨스가 시작되며, 이는 평생의 연구 파트너가 될 수 있습니다.",
      person: "'실험복을 입은 13살 과학영재'\n뛰어난 지능과 창의적 사고를 가진 이 귀인은 당신에게 혁신적인 아이디어를 제공할 것입니다."
    },
    {
      money: "문학적 감성이 기회가 되는 해입니다. 4월에는 글쓰기 관련 수익이 생기며, 7월에는 스토리텔링 능력이 인정받습니다. 가을에는 당신의 이야기가 값진 자산이 될 것입니다.",
      love: "시적인 로맨스가 찾아오는 해입니다. 봄에는 도서관에서 운명적 만남이 있습니다. 여름에는 문학적 교감을 나누는 사람과 특별한 관계가 시작되며, 이는 아름다운 스토리가 될 것입니다.",
      person: "'노트를 들고 다니는 14살 문학소년'\n풍부한 상상력과 섬세한 감성을 가진 이 귀인은 당신의 이야기에 새로운 영감을 불어넣어줄 것입니다."
    },
    {
      money: "봉사정신이 행운을 부르는 해입니다. 3월에는 사회공헌 활동에서 기회가 찾아오며, 6월에는 의미 있는 프로젝트가 수익으로 이어집니다. 연말에는 선한 영향력이 큰 가치를 만들 것입니다.",
      love: "따뜻한 마음이 인연을 만드는 해입니다. 봄에는 봉사활동 현장에서 특별한 만남이 있습니다. 가을에는 같은 가치관을 가진 사람과 깊은 관계가 시작되며, 이는 의미 있는 동행이 될 것입니다.",
      person: "'구급상자를 든 11살 어린이 봉사대원'\n순수한 마음과 이타적 정신을 가진 이 귀인은 당신에게 삶의 진정한 가치를 일깨워줄 것입니다."
    },
    {
      money: "동화 같은 상상력이 현실이 되는 해입니다. 5월에는 창작 동화가 주목받으며, 8월에는 어린이 콘텐츠로 수익이 생깁니다. 연말에는 순수한 상상력이 새로운 비즈니스가 될 것입니다.",
      love: "동화 같은 사랑이 찾아오는 해입니다. 봄에는 놀이공원에서 운명적 만남이 있습니다. 여름에는 동심을 간직한 사람과 로맨스가 시작되며, 이는 마법 같은 이야기가 될 것입니다.",
      person: "'크레용을 든 10살 동화작가 지망생'\n풍부한 상상력과 순수한 감성을 가진 이 귀인은 당신의 삶을 동화처럼 아름답게 만들어줄 것입니다."
    },
  ]
};

// 랜덤하게 운세 선택하는 함수
export const getRandomFortune = () => {
  const randomIndex = Math.floor(Math.random() * wishes.fortune.length);
  return wishes.fortune[randomIndex];
}; 